import { useTranslation } from "react-i18next";

const KEYS = ["1", "2", "3", "4"] as const;

export const HowWeWork = () => {
  const { t } = useTranslation();
  return (
    <section className="bg-background py-24 md:py-32 border-t border-border">
      <div className="container-x">
        <div className="max-w-3xl mb-16">
          <p className="text-[10px] uppercase tracking-[0.3em] text-muted-foreground mb-6">
            {t("how.eyebrow")}
          </p>
          <h2 className="font-display text-4xl md:text-5xl font-light tracking-tight text-foreground">
            {t("how.title")}
          </h2>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-4">
          {KEYS.map((k) => (
            <article key={k} className="glass glass-shimmer rounded-2xl p-8 flex flex-col gap-6 min-h-[280px] transition-all duration-500">
              <span className="font-display text-3xl font-light text-muted-foreground">
                {String(k).padStart(2, "0")}
              </span>
              <h3 className="font-display text-xl font-medium text-foreground">
                {t(`how.steps.${k}.title`)}
              </h3>
              <p className="text-sm text-muted-foreground leading-relaxed mt-auto">
                {t(`how.steps.${k}.desc`)}
              </p>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
};
